<script>
    import Icon from "mdi-svelte";
    import { mdiMenu } from "@mdi/js";

    let menu = false;
    
    function menuToggle() {
        menu = !menu;
    }
</script>

<div class="header">
    <div class="logo">
        <a href="/">
            <img class="logo-svg" src="/src/Logo.svg" alt="" />
        </a>
    </div>
    <div class="navigation_links">
        <a href="/">
            <h3>ГЛАВНАЯ</h3>
        </a>
        <a href="/tournaments">
            <h3>ТУРНИРЫ</h3>
        </a>
        <a href="/news">
            <h3>СОБЫТИЯ</h3>
        </a>
        <a href="/about">
            <h3>ФЕДЕРАЦИЯ</h3>
        </a>
    </div>
    <div class="menu-fab pointer hover" on:click={menuToggle}>
        <Icon path={mdiMenu} size={1.2} />
    </div>
</div>

<div class="left-menu" class:opened={menu}>
    <div class="menu-background" on:click={menuToggle} />
    <div class="navigation_links">
        <a href="/" on:click={menuToggle} class="left-menu-logo">
            <div class="navigation_element">
                <img class="logo-svg" src="/src/Logo_compact.svg" alt="" />
            </div>
        </a>
        <a href="/" on:click={menuToggle}>
            <div class="navigation_element">
                <h5>ГЛАВНАЯ</h5>
            </div>
        </a>
        <a href="/tournaments" on:click={menuToggle}>
            <div class="navigation_element">
                <h5>ТУРНИРЫ</h5>
            </div>
        </a>
        <a href="/news" on:click={menuToggle}>
            <div class="navigation_element">
                <h5>СОБЫТИЯ</h5>
            </div>
        </a>
        <a href="/about" on:click={menuToggle}>
            <div class="navigation_element">
                <h5>ФЕДЕРАЦИЯ</h5>
            </div>
        </a>
    </div>
</div>

<style lang="less" global>
    @import "Header.less";
</style>